/** Dev alias avoids ad-blockers that filter `/advertisement/` in request URLs. */
const ADVERTISEMENT_PREFIX = import.meta.env.DEV
  ? "/api/v1/promo"
  : "/api/v1/advertisement"

export function advertisementApiPath(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`

  if (normalized.startsWith("/api/v1/advertisement")) {
    return normalized.replace("/api/v1/advertisement", ADVERTISEMENT_PREFIX)
  }

  return `${ADVERTISEMENT_PREFIX}${normalized}`
}
